/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ModelType } from 'src/luis/types/ModelType';
import { LuisId } from 'src/luis/types/Resource';
import { CompositeEntityStore } from 'src/luis/types/stores/entities/CompositeEntityStore';
import { EntityStore } from 'src/luis/types/stores/entities/EntityStore';
import { SimpleEntityStore } from 'src/luis/types/stores/entities/SimpleEntityStore';
import { IntentStore } from 'src/luis/types/stores/intents/IntentStore';

/**
 * Deletes the dangling pointer of the deleted feature from the models.
 *
 * @param param0.referencedFeatureId The id of the deleted feature
 * @param param0.entityStores All the available entity stores in the application
 * @param param0.intentStores All the available intent stores in the application
 */
export const deleteDanglingFeaturePointer = ({
    referencedFeatureId,
    entityStores,
    intentStores
}: {
    referencedFeatureId: LuisId;
    entityStores: EntityStore[];
    intentStores: IntentStore[];
}) => {
    entityStores
        .filter(doesEntityStoreSupportFeatures)
        .forEach(e => e.featureStoreHouse.findById(referencedFeatureId) && e.featureStoreHouse.removeById(referencedFeatureId));
    intentStores.forEach(i => i.featureStoreHouse.findById(referencedFeatureId) && i.featureStoreHouse.removeById(referencedFeatureId));
};

const doesEntityStoreSupportFeatures = (entity: EntityStore): entity is SimpleEntityStore | CompositeEntityStore =>
    entity.typeId === ModelType.Simple || entity.typeId === ModelType.Composite;
